import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Kit de Bheli copiado del portal nuevo: tokens del tema (claro y oscuro), Lexend, botones con carga y piezas tm-*.
import "./styles/kit/bheli-copper.css";
import "./styles/kit/colors.css";
import "./styles/kit/brand.css";
import "./styles/base.css";
import "./styles/kit/color-controls.css";
import "./styles/kit/team.css";
import "./styles/admin-tokens.css";
import "./styles/admin.css";
import { App } from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("No existe #root.");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
